export enum FeatureFlagKey {
    Unspecified= 0,
    BookkeepingPanel = 1,
}
